export const translations = {
  tr: {
    nav: {
      home: "Anasayfa",
      services: "Hizmetler",
      gallery: "Galeri",
      about: "Hakkımızda",
      contact: "İletişim",
      admin: "Yönetim",
    },
    hero: {
      overline: "İstanbul Organizasyon · Dijon, France",
      title_1: "Hayalinizdeki",
      title_2: "düğün burada başlar",
      subtitle:
        "Masa düzeninden sahne kurulumuna, ışıklardan gelin tahtına kadar düğününüzün her detayı bizim için bir sanat eseridir.",
      cta_primary: "Rezervasyon Yap",
      cta_secondary: "Hizmetlerimiz",
    },
    services: {
      overline: "Hizmetlerimiz",
      title: "Her detayda zarafet",
      subtitle:
        "Düğününüzün her anı için profesyonel kurulum ve dekorasyon hizmetleri sunuyoruz.",
    },
    gallery: {
      overline: "Galeri",
      title: "Anılarımızdan kareler",
      subtitle: "Birlikte yarattığımız büyüleyici anlardan örnekler.",
    },
    about: {
      overline: "Hakkımızda",
      title: "İstanbul’dan Dijon’a uzanan zarafet",
      body_1:
        "İSTANBUL ORGANİZASYON olarak yıllardır Fransa’nın kalbinde, Türk ve uluslararası ailelere benzersiz düğün deneyimleri sunuyoruz.",
      body_2:
        "Her organizasyonu özgün bir hikâye olarak ele alıyor; titiz planlama, üstün estetik ve kusursuz uygulama ile hayalinizi gerçeğe dönüştürüyoruz.",
    },
    contact: {
      overline: "İletişim",
      title: "Birlikte planlayalım",
      subtitle:
        "Düğününüzün detaylarını paylaşın, 24 saat içinde size özel teklif hazırlayalım.",
      form: {
        name: "Ad Soyad",
        email: "E-posta",
        phone: "Telefon",
        event_date: "Etkinlik Tarihi",
        event_type: "Etkinlik Türü",
        message: "Mesajınız",
        submit: "Gönder",
        sending: "Gönderiliyor...",
        success: "Mesajınız iletildi. En kısa sürede dönüş yapacağız.",
        error: "Bir hata oluştu. Lütfen tekrar deneyin.",
        event_options: {
          wedding: "Düğün",
          engagement: "Nişan",
          henna: "Kına Gecesi",
          other: "Diğer",
        },
      },
      info: {
        phone: "Telefon",
        email: "E-posta",
        address: "Adres",
        social: "Sosyal",
      },
    },
    footer: {
      tagline: "Düğününüzün her detayında zarafet.",
      rights: "Tüm hakları saklıdır.",
    },
    admin: {
      login: {
        title: "Yönetim Paneli",
        subtitle: "Giriş yapmak için bilgilerinizi girin",
        email: "E-posta",
        password: "Şifre",
        submit: "Giriş Yap",
        error: "Geçersiz e-posta veya şifre",
      },
      dashboard: {
        title: "Kontrol Paneli",
        welcome: "Hoşgeldiniz",
        logout: "Çıkış",
        tabs: {
          contacts: "Mesajlar",
          services: "Hizmetler",
          gallery: "Galeri",
        },
        contacts: {
          empty: "Henüz mesaj yok.",
          mark_read: "Okundu",
          delete: "Sil",
        },
        services: {
          add: "Yeni Hizmet",
          edit: "Düzenle",
          save: "Kaydet",
          cancel: "İptal",
          delete: "Sil",
        },
        gallery: {
          add: "Yeni Görsel",
          url_placeholder: "Görsel URL'si",
          add_btn: "Ekle",
          delete: "Sil",
        },
      },
    },
  },
  fr: {
    nav: {
      home: "Accueil",
      services: "Services",
      gallery: "Galerie",
      about: "À propos",
      contact: "Contact",
      admin: "Administration",
    },
    hero: {
      overline: "İstanbul Organizasyon · Dijon, France",
      title_1: "Le mariage de vos rêves",
      title_2: "commence ici",
      subtitle:
        "De la disposition des tables à l'installation de la scène, des lumières au trône des mariés, chaque détail est une œuvre d'art.",
      cta_primary: "Réserver",
      cta_secondary: "Nos services",
    },
    services: {
      overline: "Nos services",
      title: "L'élégance dans chaque détail",
      subtitle:
        "Nous proposons des services professionnels d'installation et de décoration pour chaque moment de votre mariage.",
    },
    gallery: {
      overline: "Galerie",
      title: "Souvenirs en images",
      subtitle: "Des instants magiques que nous avons créés ensemble.",
    },
    about: {
      overline: "À propos",
      title: "L'élégance d'Istanbul à Dijon",
      body_1:
        "Chez İSTANBUL ORGANİZASYON, nous offrons depuis des années une expérience de mariage unique aux familles turques et internationales au cœur de la France.",
      body_2:
        "Chaque organisation est une histoire singulière : planification minutieuse, esthétique supérieure et exécution impeccable.",
    },
    contact: {
      overline: "Contact",
      title: "Planifions ensemble",
      subtitle:
        "Partagez les détails de votre mariage, nous préparerons une offre sur mesure sous 24 heures.",
      form: {
        name: "Nom complet",
        email: "E-mail",
        phone: "Téléphone",
        event_date: "Date de l'événement",
        event_type: "Type d'événement",
        message: "Votre message",
        submit: "Envoyer",
        sending: "Envoi...",
        success: "Votre message a été envoyé. Nous reviendrons vers vous très bientôt.",
        error: "Une erreur s'est produite. Veuillez réessayer.",
        event_options: {
          wedding: "Mariage",
          engagement: "Fiançailles",
          henna: "Soirée Henné",
          other: "Autre",
        },
      },
      info: {
        phone: "Téléphone",
        email: "E-mail",
        address: "Adresse",
        social: "Social",
      },
    },
    footer: {
      tagline: "L'élégance dans chaque détail de votre mariage.",
      rights: "Tous droits réservés.",
    },
    admin: {
      login: {
        title: "Panneau d'administration",
        subtitle: "Entrez vos identifiants pour vous connecter",
        email: "E-mail",
        password: "Mot de passe",
        submit: "Se connecter",
        error: "E-mail ou mot de passe invalide",
      },
      dashboard: {
        title: "Tableau de bord",
        welcome: "Bienvenue",
        logout: "Déconnexion",
        tabs: {
          contacts: "Messages",
          services: "Services",
          gallery: "Galerie",
        },
        contacts: {
          empty: "Aucun message pour le moment.",
          mark_read: "Lu",
          delete: "Supprimer",
        },
        services: {
          add: "Nouveau service",
          edit: "Modifier",
          save: "Enregistrer",
          cancel: "Annuler",
          delete: "Supprimer",
        },
        gallery: {
          add: "Nouvelle image",
          url_placeholder: "URL de l'image",
          add_btn: "Ajouter",
          delete: "Supprimer",
        },
      },
    },
  },
};
